import React from 'react';
import {IGroup, IService} from 'anuro-platform-core';

interface Props {
  services: IService[];
  groups: IGroup[];
}

export const BaseContext = React.createContext<Props>({ services: [], groups: [] });
